import { useEffect, useRef } from 'react'
import { PARCEIROS_BG } from './parceirosBrand'

function seededRandom(seed: number) {
  let value = seed
  return () => {
    value = (value * 9301 + 49297) % 233280
    return value / 233280
  }
}

export function ParceirosBackdrop() {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const observedCanvas = canvasRef.current
    if (!observedCanvas) return undefined

    function draw() {
      const currentCanvas = canvasRef.current
      if (!currentCanvas) return

      const rect = currentCanvas.getBoundingClientRect()
      const ratio = window.devicePixelRatio || 1
      currentCanvas.width = Math.round(rect.width * ratio)
      currentCanvas.height = Math.round(rect.height * ratio)

      const ctx = currentCanvas.getContext('2d')
      if (!ctx) return

      ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
      ctx.clearRect(0, 0, rect.width, rect.height)

      const random = seededRandom(27)
      const count = Math.min(88, Math.max(36, Math.floor((rect.width * rect.height) / 11000)))

      for (let index = 0; index < count; index += 1) {
        const x = random() * rect.width
        const y = random() * rect.height
        const bright = random() > 0.82
        const radius = bright ? 1.35 + random() * 1.1 : 0.55 + random() * 0.8
        const alpha = bright ? 0.45 + random() * 0.35 : 0.18 + random() * 0.24

        ctx.beginPath()
        ctx.fillStyle = `rgba(255,255,255,${alpha})`
        ctx.shadowColor = bright ? 'rgba(255,255,255,0.75)' : 'transparent'
        ctx.shadowBlur = bright ? 8 : 0
        ctx.arc(x, y, radius, 0, Math.PI * 2)
        ctx.fill()
        ctx.shadowBlur = 0
      }
    }

    draw()
    const observer = new ResizeObserver(draw)
    observer.observe(observedCanvas)
    window.addEventListener('resize', draw)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', draw)
    }
  }, [])

  return (
    <div
      aria-hidden
      className='pointer-events-none absolute inset-0 overflow-hidden'
      style={{
        background: `linear-gradient(135deg, ${PARCEIROS_BG} 0%, #1a0a3e 48%, #2d1b4e 100%)`,
      }}
    >
      <canvas ref={canvasRef} className='absolute inset-0 h-full w-full' />
      <div
        className='absolute inset-0'
        style={{
          backgroundImage: [
            'radial-gradient(ellipse at top right, rgba(233,30,99,0.15) 0%, transparent 50%)',
            'radial-gradient(ellipse at bottom left, rgba(255,0,110,0.10) 0%, transparent 50%)',
            'radial-gradient(circle at 73% 28%, rgba(233,30,99,0.10), transparent 20%)',
            'radial-gradient(circle at 36% 72%, rgba(255,0,110,0.08), transparent 18%)',
          ].join(','),
        }}
      />
    </div>
  )
}
